import React from "react";
import { Timeline, Events, UrlButton, ImageEvent } from "@merc/react-timeline";

// projects
// import L_overstockgif from "../../assets/img/projects/overstockgif.gif";
// import L_faasosgif from "../../assets/img/projects/faasosgif.gif";
// import L_lumen5gif from "../../assets/img/projects/lumen5gif.gif";
import L_WeatherNew from "../../assets/img/projects/weatherNew.png";
import L_CollabDocs from "../../assets/img/projects/CollabDocs.gif";
import L_kbcgif from "../../assets/img/projects/kbcgif.gif";
import L_e_commerce from "../../assets/img/projects/e_commercegif.gif";
import L_chatapp from "../../assets/img/projects/chatapp.gif";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

// skills
import L_REACT from "../../assets/img/skills/react.svg";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
// import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import Image from "react-bootstrap/Image";
// import L_HTML5 from "../../assets/img/skills/html-5.svg";
// import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_MATERIALUI from "../../assets/img/skills/material-ui-1.svg";
// import L_REACT_BOOTSTRAP from "../../assets/img/skills/react-bootstrap.svg";
import L_STYLED_COMP from "../../assets/img/skills/styled-components.svg";
import L_OpenWeatherAPI from "../../assets/img/skills/OpenWeatherAPI.png";
import L_SocketIO from "../../assets/img/skills/socket-io-svgrepo-com.svg";
import L_ChakraUI from "../../assets/img/skills/chakra-ui-icon.svg";
import L_Cloudinary from "../../assets/img/skills/cloudinary.png";
import L_NEXT_JS from "../../assets/img/skills/next-js.svg";
import L_TYPESCRIPT from "../../assets/img/skills/typescript.svg";
import L_TAILWIND from "../../assets/img/skills/tailwindcss.svg";
import L_WEBSOCKETS from "../../assets/img/skills/websockets.svg";
import L_MONGOOSE from "../../assets/img/skills/mongoose.svg";
import L_CICD from "../../assets/img/skills/cicd.svg";
import L_GROQ from "../../assets/img/skills/groq.svg";
import L_TIPTAP from "../../assets/img/skills/tiptap.svg";
import L_ZOD from "../../assets/img/skills/zod.svg";
import L_NEXTAUTH from "../../assets/img/skills/nextauth.svg";

import "./projects-timeline.styles.css";

const TimeLine = () => {
  return (
    <div>
      <h1 className="pt-3 text-center font-details-b pb-3">PROJECTS</h1>
      <Timeline>
        <Events>
          {/* Project: Overstock Clone */}
          {/* <ImageEvent
            className="text-center"
            text="Overstock"
            src={L_overstockgif}
            alt="Overstock"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;This is a clone of
                        “Overstock.com” in which I implemented Sofa's page, Cart
                        page, Products Category Section, Payment page and many
                        more
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>Sort & Filter option</li>
                          <li>Add to cart option</li>
                          <li>Respoisive Design</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_HTML5}
                                alt="HTML 5"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              HTML5
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_CSS3}
                                alt="CSS 3"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              CSS3
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_JAVASCRIPT}
                                alt="JavaScript"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              JavaScript
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton
                  href="https://overstockcloneproj.netlify.app/"
                  target="_blank"
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href="https://github.com/Shiva7781/overstock_project"
                  target="_blank"
                >
                  SOURCE CODE
                </UrlButton>
                <UrlButton
                  href="https://www.linkedin.com/feed/update/urn:li:activity:6891718258848878592/"
                  target="_blank"
                >
                  WATCH VIDEO
                </UrlButton>
              </div>
            </div>
          </ImageEvent> */}

          {/* Project: Faasos Clone */}
          {/* <ImageEvent
            className="text-center"
            text="Faasos"
            src={L_faasosgif}
            alt="faasos"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;This is a clone of
                        “faasos.com” in which I implemented Cart page, Products
                        Category Section, Payment page and many more.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>Sorting & Filtering option</li>
                          <li>add to card page effect on home page</li>
                          <li>Real-time API calls with Backend features</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_HTML5}
                                alt="HTML 5"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              HTML5
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_CSS3}
                                alt="CSS 3"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              CSS3
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_JAVASCRIPT}
                                alt="JavaScript"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              JavaScript
                            </span>
                          </li>

                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NODE_JS}
                                alt="Node.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_EXPRESS}
                                alt="Express"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGODB}
                                alt="MongoDB"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              MongoDB
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton
                  href="https://faasos7781.netlify.app/"
                  target="_blank"
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href="https://github.com/Shiva7781/faasos-website"
                  target="_blank"
                >
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent> */}

          {/* Project: Lumen5 Clone */}
          {/* <ImageEvent
            className="text-center"
            text="Lumen5"
            src={L_lumen5gif}
            alt="Lumen5"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;This is a clone of
                        “lumen5” in which I implemented subscription page and
                        many more.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>
                            Lumen5 is a website where a user can easily make
                            videos for content marketing, through leadership and
                            brand awareness in a snap.
                          </li>
                          <li>
                            You can take monthly subscription & yearly
                            subscription as well
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>

                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT_BOOTSTRAP}
                                alt="React_Bootstrap"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              React-Bootstrap
                            </span>
                          </li>

                          <li>
                            <span className="p-2">
                              <Image
                                src={L_STYLED_COMP}
                                alt="Styled Components"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Styled Components
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://mylumen5.netlify.app/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href="https://github.com/Shiva7781/lumen5"
                  target="_blank"
                >
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent> */}

          {/* Project: Collab Docs — Local-First Collaborative Document Editor */}
          <ImageEvent
            className="text-center"
            text="Collab Docs"
            src={L_CollabDocs}
            alt="Collab Docs"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;A production-grade local-first collaborative
                        document editor — combining offline editing, real-time sync, version control,
                        secure multi-user access, and AI-assisted writing.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>
                            Local-first architecture — edit documents offline with IndexedDB as
                            primary storage, zero network blocking
                          </li>
                          <li>
                            Background sync engine — automatic merge on reconnect without
                            overwriting offline work
                          </li>
                          <li>
                            Real-time collaboration over WebSockets with Y.js YATA deterministic
                            conflict resolution
                          </li>
                          <li>
                            Rich text editing with Tiptap 3 and real-time collaboration extensions
                          </li>
                          <li>
                            Version history &amp; time travel — save named snapshots and restore
                            without corrupting live collaborators
                          </li>
                          <li>
                            Invite collaborators by email with Owner, Editor, and Viewer role
                            management
                          </li>
                          <li>
                            Role-based access enforced at WebSocket level — viewers cannot push
                            document updates
                          </li>
                          <li>
                            AI writing assistant — continue writing, summarize, fix grammar via
                            Groq Llama 3.3 70B
                          </li>
                          <li>
                            Production safeguards — NextAuth JWT auth, Zod payload validation, 5 MB
                            sync limits, and tenant-scoped MongoDB access
                          </li>
                          <li>
                            Split production architecture — Next.js on Vercel + Y.js WebSocket
                            server on Railway, with GitHub Actions CI/CD
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NEXT_JS}
                                alt="Next.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Next.js 16
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_TYPESCRIPT}
                                alt="TypeScript"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              TypeScript
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NODE_JS}
                                alt="Node.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGODB}
                                alt="MongoDB"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              MongoDB
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGOOSE}
                                alt="Mongoose"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Mongoose
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_TAILWIND}
                                alt="Tailwind CSS"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Tailwind CSS
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_TIPTAP}
                                alt="Tiptap"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Tiptap
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_WEBSOCKETS}
                                alt="WebSockets"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              WebSockets / Y.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NEXTAUTH}
                                alt="NextAuth"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              NextAuth
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_ZOD}
                                alt="Zod"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Zod
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_CICD}
                                alt="CI/CD"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              CI/CD
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_GROQ}
                                alt="Groq"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Groq AI
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton
                  href="https://collab-doc-editor-rho.vercel.app/"
                  target="_blank"
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href="https://github.com/Shiva7781/collab-doc-editor"
                  target="_blank"
                >
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>


          {/* Project: Chat App ( MERN ) */}
          <ImageEvent className="text-center" text="Chat App" src={L_chatapp} alt="Chat App">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;A real-time chat app with user auth,
                        search, group chat, typing indicators, emojis, and notifications. Admins
                        manage group members, users can view profiles and group info via modals.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>Users Sign-in/Sign-up authentication.</li>
                          <li>User can create a new group and rename the group.</li>
                          <li>User can search other users based on name or email.</li>
                          <li>
                            Once the user select one of the user or group, transition to a chat
                            section.
                          </li>
                          <li>
                            Navbar with notification for unread messages and modal for profile and
                            group info.
                          </li>
                          <li>
                            Only group admin can remove someone from the group or group members can
                            leave the group.
                          </li>
                          <li>
                            In chat section real time typing indicator animation and user can send
                            the emojis as well.
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NODE_JS}
                                alt="Node.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_EXPRESS}
                                alt="Express"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGODB}
                                alt="MongoDB"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              MongoDB
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_Cloudinary}
                                alt="Cloudinary"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Cloudinary
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_SocketIO}
                                alt="Socket.IO"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Socket.IO
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_ChakraUI}
                                alt="Chakra UI"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Chakra UI
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://chat-app-shiva7781.netlify.app/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://github.com/Shiva7781/chat_app" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: E-Commerce */}
          <ImageEvent className="text-center" text="E-Commerce" src={L_e_commerce} alt="E-Commerce">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp; Built a custom e-commerce website that
                        acts exactly like any other e-commerce website
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>Users Sign-in/Sign-up authentication</li>
                          <li>New sale announcement section</li>
                          <li>Fetching all product data from database</li>
                          <li>Product filters by size and colors</li>
                          <li>Sorting by ascending and descending</li>
                          <li>Product section with add to cart functionality</li>
                          <li>Payment Section with Stripe Payment Processing</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_NODE_JS}
                                alt="Node.js"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Node.js
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_EXPRESS}
                                alt="Express"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Express
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MONGODB}
                                alt="MongoDB"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              MongoDB
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REDUX}
                                alt="Redux Toolkit"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Redux Toolkit
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_MATERIALUI}
                                alt="Material UI"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              Material UI
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_STYLED_COMP}
                                alt="Styled Components"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Styled Components
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://shiva7781e-commerce.netlify.app/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://github.com/Shiva7781/E-commerce" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: KBC App */}
          <ImageEvent className="text-center" text="KBC App" src={L_kbcgif} alt="KBC App">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;Clone of KBC which acts exactly like a
                        real KBC, on giving correct answer for a question you get some prize money,
                        and on wrong answer you get eliminate form the game.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>
                            Sounds Implemented :- Start, Waiting, Correct Answer, Wrong Answer.
                          </li>
                          <li>On correct answer jump to next question.</li>
                          <li>
                            On wrong answer prize money will be given whatever amount earned till
                            last question.
                          </li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://react-kbc-app-7781.netlify.app/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://github.com/Shiva7781/react-kbc-app" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: WeatherNew App Clone */}
          <ImageEvent
            className="text-center"
            text="Weather App"
            src={L_WeatherNew}
            alt="Weather App"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>&nbsp;Based on user input or automatic
                        geolocation, a weather app will display the sun, moon, and current
                        forecasted weather for the next seven days, depending on the user's
                        location.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>Provide Real-time data</li>
                          <li>Automatically detect user location by asking location permission</li>
                        </ul>
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_REACT}
                                alt="React"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              React
                            </span>
                          </li>

                          <li>
                            <span className="p-2">
                              <Image
                                src={L_OpenWeatherAPI}
                                alt="OpenWeather API"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              OpenWeather API
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://weather-app-shiva7781.netlify.app/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://github.com/Shiva7781/Weather_App" target="_blank">
                  SOURCE CODE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

        </Events>
      </Timeline>
    </div>
  );
};

export default TimeLine;
